// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/PriceAreaAssortment.yaml
// Generated: 2026-10-20T12:35:31.056Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreatePriceAreaAssortment, UpdatePriceAreaAssortment, PriceAreaAssortment } from '@/types/forestry/PriceAreaAssortment';

/**
 * PriceAreaAssortment Service
 * CRUD operations for PriceAreaAssortment via the ABP API.
 */
export const priceAreaAssortmentService = new EntityService<PriceAreaAssortment, CreatePriceAreaAssortment, UpdatePriceAreaAssortment>(
  '/api/forestry/priceareaassortment',
  'PriceAreaAssortment',
);
